import { createSlice } from "@reduxjs/toolkit";

const plansSlice = createSlice({
  name: "plan",
  initialState: {
    planModalClose: true,
    activeModalClose: true,
    accessModalClose: true,
    freeTrialModalClose: true,
    premiumAlertModalClose: true,
    activeMsg: "",
    accessMsg: "",
    subscriptionPlan: true,
    premiumPlanId: null,
  },
  reducers: {
    setPlanModalClose: (state, action) => {
      state.planModalClose = action.payload;
    },
    setActiveModalClose: (state, action) => {
      state.activeModalClose = action.payload;
    },
    setAccessModalClose: (state, action) => {
      state.accessModalClose = action.payload;
    },
    setFreeTrialModalClose: (state, action) => {
      state.freeTrialModalClose = action.payload;
    },
    setPremiumAlertModalClose: (state, action) => {
      state.premiumAlertModalClose = action.payload;
    },
    setReindexAlertModalClose: (state, action) => {
      state.reindexAlertModalClose = action.payload;
    },
    setPremiumPlanId: (state, action) => {
      state.premiumPlanId = action.payload;
    },
    setActiveMsg: (state, action) => {
      state.activeMsg = action.payload;
    },
    setAccessMsg: (state, action) => {
      state.accessMsg = action.payload;
    },
    setSubscriptionPlan: (state, action) => {
      state.subscriptionPlan = action.payload;
    },
  },
});

export const {
  setPlanModalClose,
  setActiveModalClose,
  setAccessModalClose,
  setFreeTrialModalClose,
  setPremiumAlertModalClose,
  setActiveMsg,
  setAccessMsg,
  setSubscriptionPlan,
  setPremiumPlanId,
} = plansSlice.actions;
export default plansSlice;




// import { createSlice } from "@reduxjs/toolkit";

// const plansSlice = createSlice({
//   name: "plan",
//   initialState: {
//     planModalClose: true,
//     activeModalClose: true,
//     activeMsg: "",
//   },
//   reducers: {
//     setPlanModalClose: (state, action) => {
//       state.planModalClose = action.payload;
//     },
//     setActiveModalClose: (state, action) => {
//       state.activeModalClose = action.payload;
//     },
//     setActiveMsg: (state, action) => {
//       state.activeMsg = action.payload;
//     },
//   },
// });

// export const { setPlanModalClose, setActiveModalClose, setActiveMsg } =
//   plansSlice.actions;
// export default plansSlice;


